import { ref } from 'vue'
import type { CountryPrefix } from '~/services/api/phone/CountryPrefix'
import { getCountryPrefixes } from '~/services/api/phone/getCountryPrefixes'

const cache = ref<CountryPrefix[]>([])
const isLoading = ref(false)
let loadPromise: Promise<void> | null = null

const DEFAULT_COUNTRIES: CountryPrefix[] = getCountryPrefixes()

export function useCountryPrefixes() {
  async function load() {
    if (cache.value.length > 0 || isLoading.value) return
    if (loadPromise) return loadPromise

    isLoading.value = true
    loadPromise = Promise.resolve()
      .then(() => {
        cache.value = DEFAULT_COUNTRIES
      })
      .finally(() => {
        isLoading.value = false
      })

    return loadPromise
  }

  return { countries: cache, loading: isLoading, load, defaultCountries: DEFAULT_COUNTRIES }
}
